export const config = {
    appname: 'thailife',
    prefix: 'THL',
    app_id: '1737548692935071',
    facebook_app_id: '1737548692935071',
    debug: true,

    // ------------- Development Settings ----------------
    api: 'apithl2',
    agency_id: '',
    bzbs_url: 'https://apithl2.buzzebees-dev.com',
    bzbs_module_url: 'https://thailifemodule.buzzebees-dev.com',
    bzbs_add_item_from_list: 'https://dev.buzzebees.com/api/cart/',
    bzbs_blob_url: 'https://devstoragebuzzebees.blob.core.windows.net',
    bzbs_shopping_cart_url: 'https://devc.buzzebees.com',
    bzbs_add_item: 'https://devc.buzzebees.com/payment/AddItem.aspx?id=',
    bzbs_shopping_basket: 'https://devc.buzzebees.com/paymentV2/cart.aspx',
    bzbs_web_url: 'https://dew.buzzebees.com',
    bzbs_point_expire: 'https://dew.buzzebees.com/Views/Point/Expire.aspx?token=',
    api_shoppingcart_url: 'https://shoppingcartmodule.buzzebees-dev.com',
    web_shoppingcart_url: 'https://shoppingcartservice.buzzebees-dev.com',
    misc_url: 'https://devmisc.buzzebees.com',
    bzbs_ga_id: '',
    thailife_consent_url: 'https://uat-superapp-api.thailife.com/buzzebees',
    // ------------------ End Settings ---------------------

    fb_log_on_url: 'https://www.facebook.com/dialog/oauth?',
    fb_permissions: [
        'email',
    ],
    mainConfig: {
        DashboardConfig: "dashboard_thailife",
        MenuConfig: "menu_thailife",
        CampaignListConfig: "campaign_thailife",
        CampaignHeaderConfig: "thailife",
        purchaseListConfig: "purchase"
    },
};
